import SectionDescritpion from "./SectionDescritpion";

export default SectionDescritpion;
